import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa6";
import { MdOutlineMailLock } from "react-icons/md";
import "../css/footer.css"


const Footer = () => {
  const handleemail=()=>{
    window.location = "mailto:missionaryabraham@yahoo.com";
  }



  return (
    <div className='footermain'>
         <div className='footerbody'>
            <p><a href='https://www.linkedin.com/in/abraham-olowu-segun/' target='_blank' rel="noreferrer"><FaLinkedin /></a></p>
             <p><a href='https://twitter.com/home' target='_blank' rel="noreferrer"><FaXTwitter /></a></p>
             <p><a href='https://github.com/abrahamsegun' target='_blank' rel="noreferrer"><FaGithub></FaGithub></a></p>
             <p onClick={handleemail}><MdOutlineMailLock /></p>
         </div>
         <div className='copy'>
         &copy; 2024 Abraham Olowu
         </div>

     
    </div>
  )
}

export default Footer
